var CI_LEVEL, COEFFICIENTS, EFFECT_FIELDS_TO_UPDATE, EFFECT_KEYS, EMPTY_DATA, NMA_OUTCOME_PREFIX, NmaInterventionType, NmaOutcomeDataType, NmaOutcomeDocShape, OUTCOME_FIELDS_TO_UPDATE, OUTCOME_QUALITIES, REGULAR_TO_NMA_QUALITY_MODIFIERS, THRESHOLDS, addDataToOutcome, addMissingInterventions, calculateThreshold, changeSign, comparatorMapper, convertRegularOutcomeDataToNma, dataItemPairKey, flipOutcomeData, gdtDataToNmaData, gdtInterventionToNmaVizIntervention, gdtOutcomeDataToNmaOutcomeData, gdtOutcomeToNmaComparison, gdtOutcomeToNmaVizOutcomeForImport, gdtOutcomeTypeToDefaultEffectMeasure, gdtOutcomeTypeToNmaVizOutcomeType, get, getAllGdtDataForOutcome, getMappingStepData, getOutcomesData, getQualityComponentString, getTranslationKeyPostFix, importNMAData, interventionMapper, isAcpFeaturesOn, isNaN, mergeDefinedImportedFields, mergeEffectData, mergeOutcomeDataItem, mergeQuestionWithInterventionsAndOutcomes, nmaDataToGdtData, nmaDataToVizData, nmaOutcomeDataToGdtData, nmaVizInterventionToGdtIntervention, parseEstimate, parseImportResultsToGdtOutcome, partition, pickOneToOneGdtAndNmaOutcomeDataProps, pluck, regularGdtQuestionToNmaInterventionsAndOutcomes, sanitizeInt, sanitizeStr, _ref, _ref1, _ref2,
  __indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

_ref = require('lodash'), get = _ref.get, isNaN = _ref.isNaN;

flipOutcomeData = NmaComponents.flipOutcomeData, getOutcomesData = NmaComponents.getOutcomesData;

_ref1 = require('lib/immutable_utils'), partition = _ref1.partition, pluck = _ref1.pluck;

isAcpFeaturesOn = require('stores/utils/etd_template_helper').isAcpFeaturesOn;

_ref2 = require('lib/outcomes_helper'), THRESHOLDS = _ref2.THRESHOLDS, COEFFICIENTS = _ref2.COEFFICIENTS;

NMA_OUTCOME_PREFIX = require('lib/doc_prefixes').nmaOutcome;

NmaInterventionType = require('lib/db_docs/field_types/nma_intervention_type');

NmaOutcomeDataType = require('lib/db_docs/field_types/nma_outcome_data_type');

NmaOutcomeDocShape = require('lib/db_docs/doc_shapes/nma_outcome_doc_shape');

CI_LEVEL = 0.95;

gdtInterventionToNmaVizIntervention = function(interventionImm) {
  return {
    id: interventionImm.get('_id'),
    name: interventionImm.get('name')
  };
};

gdtOutcomeTypeToNmaVizOutcomeType = function(outcomeType) {
  switch (outcomeType) {
    case 'dich':
      return 'Dichotomous';
    case 'cont':
      return 'Continuous';
    case 'timeToEvent':
      return 'TimeToEvent';
    default:
      return 'Other';
  }
};

gdtOutcomeToNmaVizOutcomeForImport = function(outcomeImm) {
  return {
    id: outcomeImm.get('_id'),
    higherIsBetter: Boolean(outcomeImm.get('higherIsBetter')),
    name: outcomeImm.get('name'),
    type: gdtOutcomeTypeToNmaVizOutcomeType(outcomeImm.get('type'))
  };
};

gdtOutcomeTypeToDefaultEffectMeasure = function(outcomeType) {
  switch (outcomeType) {
    case 'dich':
      return 'RR';
    case 'cont':
      return 'MD';
    case 'timeToEvent':
      return 'HR';
    default:
      return 'Other';
  }
};

parseEstimate = function(estimates, estimateType) {
  var estimate, estimateObj;
  estimate = estimates[estimateType];
  if (!estimate) {
    return;
  }
  estimateObj = {
    ciLevel: CI_LEVEL,
    absoluteEffectCiLevel: CI_LEVEL
  };
  return _.extend(estimateObj, _.pick(estimate, 'ciHigh', 'ciLow', 'effectMeasure', 'i2', 'incoherence', 'value', 'absoluteEffectValue', 'absoluteEffectCiLow', 'absoluteEffectCiHigh', 'autoCalculateAbsoluteEffect'));
};

parseImportResultsToGdtOutcome = function(_arg, outcomeId) {
  var comparisons, data, interventions, usedInterventionIds;
  comparisons = _arg.comparisons, interventions = _arg.interventions;
  data = _.map(comparisons, function(_arg1) {
    var comparatorId, estimates, interventionId, outcomes;
    comparatorId = _arg1.comparatorId, interventionId = _arg1.interventionId, outcomes = _arg1.outcomes;
    estimates = get(outcomes, "" + outcomeId + ".estimates", []);
    return {
      comparatorId: comparatorId,
      interventionId: interventionId,
      outcomeId: outcomeId,
      numberOfStudies: get(outcomes, "" + outcomeId + ".numberOfStudies"),
      totalNumberOfParticipants: get(outcomes, "" + outcomeId + ".totalNumberOfParticipants"),
      nmaEffect: parseEstimate(estimates, 'network'),
      directEffect: parseEstimate(estimates, 'direct'),
      indirectEffect: parseEstimate(estimates, 'indirect')
    };
  });
  usedInterventionIds = _.chain(data).map(function(comparison) {
    return [comparison.interventionId, comparison.comparatorId];
  }).flatten().uniq().value();
  return {
    interventions: interventions,
    data: data,
    usedInterventionIds: usedInterventionIds
  };
};

nmaVizInterventionToGdtIntervention = function(_arg) {
  var id, name;
  id = _arg.id, name = _arg.name;
  return {
    _id: id,
    name: name,
    namesFromFiles: [name]
  };
};

addMissingInterventions = function(question, interventionsToImport) {
  return question.update('interventions', function(currentInterventions) {
    if (currentInterventions == null) {
      currentInterventions = Immutable.List();
    }
    interventionsToImport = _.chain(interventionsToImport).map(nmaVizInterventionToGdtIntervention).reject(function(interventionToCheck) {
      return currentInterventions.some(function(intervention) {
        return intervention.get('_id') === interventionToCheck._id;
      });
    }).map(function(intervention) {
      return Immutable.fromJS(intervention);
    }).value();
    return currentInterventions.concat(interventionsToImport);
  });
};

EFFECT_FIELDS_TO_UPDATE = ['value', 'ciLow', 'ciHigh', 'ciLevel', 'effectMeasure', 'effectMeasureOther', 'pValue', 'i2', 'incoherence', 'autoCalculateAbsoluteEffect', 'absoluteEffectValue', 'absoluteEffectCiLow', 'absoluteEffectCiHigh', 'absoluteEffectCiLevel'];

OUTCOME_FIELDS_TO_UPDATE = ['interventionData', 'comparisonData', 'numberOfStudies', 'totalNumberOfParticipants'];

EFFECT_KEYS = ['nmaEffect', 'directEffect', 'indirectEffect'];

mergeDefinedImportedFields = function(targetImm, importedImm, fields) {
  return fields.reduce((function(acc, field) {
    var importedVal;
    importedVal = importedImm.get(field);
    if (importedVal == null) {
      return acc;
    }
    return acc.set(field, importedVal);
  }), targetImm);
};

mergeEffectData = function(existingDataItem, importedDataItem, effectKey) {
  var existingEffect, importedEffect, mergedEffect;
  importedEffect = importedDataItem.get(effectKey);
  if (importedEffect == null) {
    return existingDataItem;
  }
  existingEffect = existingDataItem.get(effectKey) || Immutable.Map();
  mergedEffect = mergeDefinedImportedFields(existingEffect, importedEffect, EFFECT_FIELDS_TO_UPDATE);
  return existingDataItem.set(effectKey, mergedEffect);
};

mergeOutcomeDataItem = function(existingDataItem, importedDataItem) {
  var mergedDataItem;
  mergedDataItem = EFFECT_KEYS.reduce((function(acc, effectKey) {
    return mergeEffectData(acc, importedDataItem, effectKey);
  }), existingDataItem);
  return mergeDefinedImportedFields(mergedDataItem, importedDataItem, OUTCOME_FIELDS_TO_UPDATE);
};

dataItemPairKey = function(dataItemImm) {
  return "" + (dataItemImm.get('interventionId')) + "\u0000" + (dataItemImm.get('comparatorId'));
};

addDataToOutcome = function(outcome, data, interventionsMapping, interventionIdsToImport) {
  return outcome.update('data', function(currentData) {
    var idx, importedDataItem, importedRows, indexByPair, item, items, key, _i, _j, _len, _len1;
    if (currentData == null) {
      currentData = Immutable.List();
    }
    importedRows = _.chain(data).map(function(dataItem) {
      var comparatorId, comparatorMappingValue, interventionId, interventionMappingValue;
      interventionId = dataItem.interventionId, comparatorId = dataItem.comparatorId;
      interventionMappingValue = interventionsMapping.get(interventionId, interventionId);
      comparatorMappingValue = interventionsMapping.get(comparatorId, comparatorId);
      if (interventionMappingValue !== '_add' && interventionMappingValue !== '_delete' && interventionMappingValue !== '_assign') {
        dataItem.interventionId = interventionMappingValue;
      }
      if (comparatorMappingValue !== '_add' && comparatorMappingValue !== '_delete' && comparatorMappingValue !== '_assign') {
        dataItem.comparatorId = comparatorMappingValue;
      }
      return dataItem;
    }).filter(function(_arg) {
      var comparatorId, interventionId;
      interventionId = _arg.interventionId, comparatorId = _arg.comparatorId;
      return __indexOf.call(interventionIdsToImport, interventionId) >= 0 && __indexOf.call(interventionIdsToImport, comparatorId) >= 0;
    }).map(function(dataItem) {
      return Immutable.fromJS(dataItem);
    }).value();
    items = currentData.toArray();
    indexByPair = new Map();
    for (idx = _i = 0, _len = items.length; _i < _len; idx = ++_i) {
      item = items[idx];
      indexByPair.set(dataItemPairKey(item), idx);
    }
    for (_j = 0, _len1 = importedRows.length; _j < _len1; _j++) {
      importedDataItem = importedRows[_j];
      key = dataItemPairKey(importedDataItem);
      if (indexByPair.has(key)) {
        idx = indexByPair.get(key);
        items[idx] = mergeOutcomeDataItem(items[idx], importedDataItem);
      } else {
        indexByPair.set(key, items.length);
        items.push(importedDataItem);
      }
    }
    return Immutable.List(items);
  });
};

importNMAData = function(data, usedInterventions, question, outcome, interventionsMapping, fileName) {
  var interventionsToImport;
  interventionsToImport = _.chain(usedInterventions).map(function(intervention) {
    var mappingValue;
    mappingValue = interventionsMapping.get(intervention.id);
    if ((mappingValue == null) || mappingValue === '_delete') {
      return;
    }
    if (mappingValue === '_add') {
      return intervention;
    }
    return {
      id: mappingValue,
      name: intervention.name
    };
  }).compact().value();
  question = addMissingInterventions(question, interventionsToImport);
  outcome = addDataToOutcome(outcome, data, interventionsMapping, _.pluck(interventionsToImport, 'id'));
  outcome = outcome.set('fileName', fileName);
  return {
    question: question,
    outcome: outcome
  };
};

getMappingStepData = function(question, parsedData) {
  var data, isNewImport, mapping, matchedInterventions, questionInterventionIds, unmatchedInterventions, usedInterventionIds, usedInterventions, _ref3;
  isNewImport = question.get('interventions', Immutable.List()).isEmpty();
  usedInterventionIds = parsedData.get('usedInterventionIds', Immutable.List());
  questionInterventionIds = pluck(question.get('interventions', Immutable.List()), '_id');
  usedInterventions = parsedData.get('interventions', Immutable.List()).filter(function(intervention) {
    return usedInterventionIds.includes(intervention.get('id'));
  });
  _ref3 = partition(usedInterventions, function(intervention) {
    return isNewImport || questionInterventionIds.includes(intervention.get('id'));
  }), matchedInterventions = _ref3[0], unmatchedInterventions = _ref3[1];
  mapping = isNewImport ? _.chain(usedInterventionIds.toJS()).map(function(interventionId) {
    return [interventionId, '_add'];
  }).object().value() : _.chain(pluck(matchedInterventions, 'id').toJS()).map(function(interventionId) {
    return [interventionId, interventionId];
  }).object().value();
  data = parsedData.get('data', Immutable.List());
  return Immutable.fromJS({
    data: data,
    mapping: mapping,
    matchedInterventions: matchedInterventions,
    unmatchedInterventions: unmatchedInterventions
  });
};

EMPTY_DATA = {
  interventions: [],
  comparisons: [],
  outcomes: []
};

pickOneToOneGdtAndNmaOutcomeDataProps = function(outcomeData) {
  return _.pick(outcomeData, 'interventionData', 'comparisonData', 'numberOfStudies', 'interpretation', 'effectClassification', 'totalNumberOfParticipants', 'reverseInterpretation', 'advancedOptions', 'useAdvancedOptions', 'rct', 'estimatesEnabled', 'explanations');
};

gdtOutcomeToNmaComparison = function(interventionId, comparatorId, outcomes) {
  var outcomesData;
  outcomesData = _.chain(outcomes.toJS()).map(function(outcome) {
    var outcomeData, outcomeId, outcomeObj;
    outcomeId = outcome._id;
    outcomeData = _.find(outcome.data, function(dataItem) {
      return dataItem.interventionId === interventionId && dataItem.comparatorId === comparatorId;
    });
    if (!outcomeData) {
      return;
    }
    outcomeObj = gdtOutcomeDataToNmaOutcomeData(outcomeData, outcomeId);
    return [outcomeId, outcomeObj];
  }).compact().object().value();
  if (_.isEmpty(outcomesData)) {
    return;
  }
  return {
    interventionId: interventionId,
    comparatorId: comparatorId,
    outcomes: outcomesData
  };
};

gdtOutcomeDataToNmaOutcomeData = function(outcomeData, outcomeId) {
  var comparatorId, directEffect, effectToUse, estimates, indirectEffect, interventionId, nmaEffect;
  interventionId = outcomeData.interventionId, comparatorId = outcomeData.comparatorId;
  nmaEffect = outcomeData.nmaEffect, directEffect = outcomeData.directEffect, indirectEffect = outcomeData.indirectEffect, effectToUse = outcomeData.effectToUse;
  estimates = _.chain([['network', nmaEffect], ['direct', directEffect], ['indirect', indirectEffect]]).filter(function(_arg) {
    var value, _estimateType;
    _estimateType = _arg[0], value = _arg[1];
    return value != null;
  }).object().value();
  return _.extend({
    outcomeId: outcomeId,
    estimates: estimates,
    estimateToUse: effectToUse
  }, pickOneToOneGdtAndNmaOutcomeDataProps(outcomeData));
};

comparatorMapper = function(interventionId, outcomes) {
  return function(comparatorId) {
    if (interventionId === comparatorId) {
      return;
    }
    return gdtOutcomeToNmaComparison(interventionId, comparatorId, outcomes);
  };
};

interventionMapper = function(interventionIds, outcomes) {
  return function(interventionId) {
    return _.chain(interventionIds).map(comparatorMapper(interventionId, outcomes)).compact().value();
  };
};

gdtDataToNmaData = function(question, outcomes) {
  var comparisons, explanations, interventionIds, interventions, outcomesOrder, outcomesToPass;
  if (question.isEmpty() || outcomes.isEmpty()) {
    return EMPTY_DATA;
  }
  outcomesOrder = question.get('outcomes', Immutable.List()).toJS();
  interventions = _.map(question.get('interventions', Immutable.List()).toJS(), function(_arg) {
    var name, _id;
    _id = _arg._id, name = _arg.name;
    return {
      id: _id,
      name: name
    };
  });
  interventionIds = _.pluck(interventions, 'id');
  comparisons = _.chain(interventionIds).map(interventionMapper(interventionIds, outcomes)).flatten().value();
  outcomesToPass = _.map(outcomes.toJS(), function(outcome) {
    var outcomeType;
    outcomeType = gdtOutcomeTypeToNmaVizOutcomeType(outcome.type);
    return _.extend({
      id: outcome._id,
      type: outcomeType
    }, _.pick(outcome, 'name', 'higherIsBetter', 'baselineRisk', 'T1', 'T2', 'T3', 'units'));
  }).sort(function(a, b) {
    return outcomesOrder.indexOf(a.id) - outcomesOrder.indexOf(b.id);
  });
  explanations = question.get('explanations', Immutable.Map()).toJS();
  return {
    interventions: interventions,
    comparisons: comparisons,
    outcomes: outcomesToPass,
    explanations: explanations
  };
};

nmaOutcomeDataToGdtData = function(outcomeData, interventionId, comparatorId) {
  var estimateToUse, estimates, nmaEstimates, outcomeId;
  nmaEstimates = outcomeData.estimates, estimateToUse = outcomeData.estimateToUse, outcomeId = outcomeData.outcomeId;
  estimates = _.chain(nmaEstimates).map(function(estimate, estimateType) {
    var key;
    if (!estimate) {
      return;
    }
    key = (function() {
      switch (estimateType) {
        case 'network':
          return 'nmaEffect';
        case 'direct':
          return 'directEffect';
        case 'indirect':
          return 'indirectEffect';
        default:
          return null;
      }
    })();
    if (!key) {
      return;
    }
    return [key, estimate];
  }).compact().object().value();
  return _.extend({
    interventionId: interventionId,
    comparatorId: comparatorId,
    outcomeId: outcomeId,
    effectToUse: estimateToUse
  }, estimates, pickOneToOneGdtAndNmaOutcomeDataProps(outcomeData));
};

nmaDataToGdtData = function(data, outcomeId) {
  return _.chain(data).map(function(_arg) {
    var comparatorId, interventionId, outcomeData, outcomes;
    interventionId = _arg.interventionId, comparatorId = _arg.comparatorId, outcomes = _arg.outcomes;
    outcomeData = outcomes[outcomeId];
    if (!outcomeData) {
      return;
    }
    return nmaOutcomeDataToGdtData(outcomeData, interventionId, comparatorId);
  }).compact().value();
};

nmaDataToVizData = function(interventions, selectedInterventions, interventionComparisonPairs, comparisons, comparatorId, comparatorTableMode) {
  switch (comparatorTableMode) {
    case 'Pairwise':
      return _.map(interventionComparisonPairs, function(_arg) {
        var comparator, comparatorId, interventionId, outcomes, rowElement;
        interventionId = _arg[0], comparatorId = _arg[1];
        rowElement = interventions.find(function(intervention) {
          return intervention.id === interventionId;
        });
        comparator = interventions.find(function(intervention) {
          return intervention.id === comparatorId;
        });
        outcomes = getOutcomesData(interventionId, comparatorId, comparisons);
        return {
          rowElement: rowElement,
          comparator: comparator,
          outcomes: outcomes
        };
      });
    case 'CommonComparator':
      return _.map(selectedInterventions, function(_arg) {
        var interventionId;
        interventionId = _arg.id;
        return {
          rowElement: interventions.find(function(intervention) {
            return intervention.id === interventionId;
          }),
          comparator: interventions.find(function(intervention) {
            return intervention.id === comparatorId;
          }),
          outcomes: getOutcomesData(interventionId, comparatorId, comparisons)
        };
      });
    case 'CommonIntervention':
      return _.map(selectedInterventions, function(_arg) {
        var interventionId;
        interventionId = _arg.id;
        return {
          rowElement: interventions.find(function(intervention) {
            return intervention.id === comparatorId;
          }),
          comparator: interventions.find(function(intervention) {
            return intervention.id === interventionId;
          }),
          outcomes: getOutcomesData(comparatorId, interventionId, comparisons)
        };
      });
    default:
      return [];
  }
};

getAllGdtDataForOutcome = function(outcome) {
  var alreadyPresentData, comparatorId, data, gdtData, interventionId, interventionIds, nmaComparison, nmaDataFlipped, outcomeData, outcomeId, _i, _j, _len, _len1;
  outcomeId = outcome._id, data = outcome.data;
  interventionIds = _.chain(data).map(function(_arg) {
    var comparatorId, interventionId;
    comparatorId = _arg.comparatorId, interventionId = _arg.interventionId;
    return [comparatorId, interventionId];
  }).flatten().uniq().value();
  alreadyPresentData = {};
  _.each(data, function(dataItem) {
    var comparatorId, interventionId;
    interventionId = dataItem.interventionId, comparatorId = dataItem.comparatorId;
    if (!alreadyPresentData["" + interventionId + "-" + comparatorId]) {
      return alreadyPresentData["" + interventionId + "-" + comparatorId] = dataItem;
    }
  });
  for (_i = 0, _len = interventionIds.length; _i < _len; _i++) {
    interventionId = interventionIds[_i];
    for (_j = 0, _len1 = interventionIds.length; _j < _len1; _j++) {
      comparatorId = interventionIds[_j];
      if (alreadyPresentData["" + interventionId + "-" + comparatorId]) {
        continue;
      }
      nmaComparison = gdtOutcomeToNmaComparison(comparatorId, interventionId, Immutable.List([outcome]));
      if (!nmaComparison) {
        continue;
      }
      outcomeData = nmaComparison.outcomes[outcomeId];
      if (!outcomeData) {
        continue;
      }
      nmaDataFlipped = flipOutcomeData(outcomeData, false);
      gdtData = nmaOutcomeDataToGdtData(nmaDataFlipped, interventionId, comparatorId);
      alreadyPresentData["" + interventionId + "-" + comparatorId] = gdtData;
    }
  }
  return _.values(alreadyPresentData);
};

getTranslationKeyPostFix = function() {
  if (isAcpFeaturesOn()) {
    return '_acp';
  } else {
    return '';
  }
};

calculateThreshold = function(utility, thresholdIndex, denominator, higherIsBetter) {
  var disutility;
  disutility = higherIsBetter ? utility : 1 - parseFloat(utility);
  return Number(((THRESHOLDS[thresholdIndex] - (COEFFICIENTS[thresholdIndex] * disutility)) * denominator).toFixed(0));
};

sanitizeInt = function(value) {
  var valueInt;
  if (value == null) {
    return;
  }
  if (value === '') {
    return;
  }
  valueInt = parseInt(value);
  if (isNaN(valueInt)) {
    return;
  }
  return valueInt;
};

sanitizeStr = function(value) {
  var trimmed;
  if (value == null) {
    return;
  }
  trimmed = value.trim();
  if (trimmed === '') {
    return;
  }
  return trimmed;
};

OUTCOME_QUALITIES = [void 0, 'Very Low', 'Low', 'Moderate', 'High'];

REGULAR_TO_NMA_QUALITY_MODIFIERS = {
  'ExtremelySerious': 'Extremely serious',
  'VerySerious': 'Very serious',
  'Serious': 'Serious',
  'None': 'Not serious',
  'No': 'No',
  'Yes': 'Yes',
  'Large': 'Large',
  'VeryLarge': 'Very large',
  'ReducedForRR': 'Would reduce demonstrated effect',
  'IncreasedForRR': 'Would suggest spurious effect',
  'publication_bias_None': 'Undetected',
  'publication_bias_Serious': 'Strongly suspected'
};

getQualityComponentString = function(qualityComponent, prefix) {
  if (prefix == null) {
    prefix = '';
  }
  if (!(qualityComponent != null ? qualityComponent.label : void 0)) {
    return;
  }
  return REGULAR_TO_NMA_QUALITY_MODIFIERS["" + prefix + qualityComponent.name];
};

changeSign = function(value) {
  var valueFloat;
  if (value == null) {
    return;
  }
  if (value === '') {
    return;
  }
  valueFloat = parseFloat(value);
  if (isNaN(valueFloat)) {
    return;
  }
  return -valueFloat;
};

convertRegularOutcomeDataToNma = function(outcome, interventionId, comparatorId, outcomeId) {
  var controlParticipants, interventionParticipants, totalParticipants, _ref3;
  interventionParticipants = sanitizeInt(outcome.interventionTotal);
  controlParticipants = sanitizeInt(outcome.controlTotal);
  totalParticipants = sanitizeInt(outcome.noOfPatients);
  if (totalParticipants == null) {
    totalParticipants = (interventionParticipants != null ? interventionParticipants : 0) + (controlParticipants != null ? controlParticipants : 0);
  }
  return NmaOutcomeDataType.defaults({
    interventionId: interventionId,
    comparatorId: comparatorId,
    outcomeId: outcomeId,
    effectToUse: 'direct',
    directEffect: {
      effectMeasure: sanitizeStr(outcome.effectMeasure),
      effectMeasureOther: outcome.otherMeasure,
      certaintyAssessment: {
        overall: OUTCOME_QUALITIES[outcome.quality],
        rct: ((_ref3 = outcome.designStudies) != null ? _ref3.name : void 0) === 'RandTrials',
        riskOfBias: getQualityComponentString(outcome.riskOfBias),
        inconsistency: getQualityComponentString(outcome.inconsistency),
        indirectness: getQualityComponentString(outcome.indirectness),
        imprecision: getQualityComponentString(outcome.imprecision),
        publicationBias: getQualityComponentString(outcome.publicationBias, 'publication_bias_'),
        largeEffect: getQualityComponentString(outcome.largeEffect),
        plausibleConfounding: getQualityComponentString(outcome.plausibleConfounding),
        doseResponseGradient: getQualityComponentString(outcome.doseResponseGradient)
      },
      ciLevel: CI_LEVEL,
      value: outcome.effectSize,
      ciLow: outcome.confidenceIntervalFrom,
      ciHigh: outcome.confidenceIntervalTo,
      autoCalculateAbsoluteEffect: false,
      absoluteEffectValue: changeSign(outcome.absEffectSize),
      absoluteEffectCiLow: changeSign(outcome.absEffectFrom),
      absoluteEffectCiHigh: changeSign(outcome.absEffectTo),
      absoluteEffectCiLevel: CI_LEVEL
    },
    interventionData: {
      numberOfParticipants: sanitizeInt(outcome.interventionTotal),
      numberOfEvents: sanitizeInt(outcome.interventionCount)
    },
    comparisonData: {
      numberOfParticipants: sanitizeInt(outcome.controlTotal),
      numberOfEvents: sanitizeInt(outcome.controlCount)
    },
    numberOfStudies: sanitizeInt(outcome.noOfStudies),
    totalNumberOfParticipants: totalParticipants,
    interpretation: outcome.narrativeDesc || outcome.comments
  });
};

regularGdtQuestionToNmaInterventionsAndOutcomes = function(question, nmaQuestionId) {
  var comparatorId, interventionId, interventions, outcomes, questionNamespace, _ref3, _ref4;
  if (!question) {
    return null;
  }
  if (((_ref3 = question.type) != null ? _ref3 : '') !== '') {
    return null;
  }
  questionNamespace = uuid.v5(nmaQuestionId, uuid.NIL);
  interventions = _.chain([question.intervention, question.comparison]).map(function(intervention) {
    return intervention != null ? intervention.trim() : void 0;
  }).compact().map(function(intervention) {
    var interventionId;
    interventionId = uuid.v5(intervention, questionNamespace);
    return NmaInterventionType.defaults({
      _id: interventionId,
      name: intervention
    });
  }).value();
  if (!(interventions.length >= 2)) {
    return null;
  }
  _ref4 = _.pluck(interventions, '_id'), interventionId = _ref4[0], comparatorId = _ref4[1];
  outcomes = _.chain(question.outcomes || []).compact().map(function(outcome) {
    var getThreshold, outcomeData, outcomeId, outcomeType;
    if (!outcome) {
      return;
    }
    outcomeId = "" + NMA_OUTCOME_PREFIX + (uuid.v5(outcome.name, questionNamespace));
    outcomeData = convertRegularOutcomeDataToNma(outcome, interventionId, comparatorId, outcomeId);
    outcomeType = outcome.type;
    if (outcomeType === 'narrative') {
      outcomeType = 'dich';
    }
    if (outcomeType === 'time_to_event') {
      outcomeType = 'timeToEvent';
    }
    if (outcomeType !== 'dich' && outcomeType !== 'cont' && outcomeType !== 'timeToEvent') {
      outcomeType = 'dich';
    }
    getThreshold = function(idx) {
      return calculateThreshold(outcome.utilityValue, idx, outcome.absDenominator, outcome.higherIsBetter);
    };
    return NmaOutcomeDocShape.defaults({
      _id: outcomeId,
      name: outcome.name,
      shortName: outcome.shortName,
      type: outcomeType,
      questionId: nmaQuestionId,
      data: [outcomeData],
      units: outcome.units,
      higherIsBetter: outcome.higherIsBetter,
      baselineRisk: outcome.lowControlRisk,
      baselineRiskType: 'outcome',
      description: outcome.comments,
      utility: outcome.utilityValue,
      T1: getThreshold(0),
      T2: getThreshold(1),
      T3: getThreshold(2)
    });
  }).compact().value();
  return {
    interventions: interventions,
    outcomes: outcomes
  };
};

mergeQuestionWithInterventionsAndOutcomes = function(currentQuestion, currentOutcomes, interventionsAndOutcomesArr) {
  var allOutcomes, currentInterventions, interventionMapById, interventionsToAdd, outcomeMapById, questionId, questionNamespace, updatedQuestion;
  if (!(interventionsAndOutcomesArr.length > 0)) {
    return {
      question: currentQuestion,
      outcomes: currentOutcomes
    };
  }
  questionId = currentQuestion.get('_id');
  currentInterventions = currentQuestion.get('interventions', Immutable.List());
  questionNamespace = uuid.v5(questionId, uuid.NIL);
  interventionMapById = _.indexBy(currentInterventions.toJS(), '_id');
  outcomeMapById = currentOutcomes.toJS();
  interventionsToAdd = [];
  _.each(interventionsAndOutcomesArr, function(_arg) {
    var newInterventions, newOutcomes;
    newInterventions = _arg.interventions, newOutcomes = _arg.outcomes;
    if (!((newInterventions != null ? newInterventions.length : void 0) > 0 && (newOutcomes != null ? newOutcomes.length : void 0) > 0)) {
      return;
    }
    _.each(newInterventions, function(newIntervention) {
      var alreadyAdded, interventionId, interventionName;
      interventionId = newIntervention._id;
      interventionName = newIntervention.name;
      if (!interventionName) {
        return;
      }
      if (!interventionMapById[interventionId]) {
        alreadyAdded = _.find(interventionsToAdd, function(i) {
          return i._id === interventionId;
        });
        if (!alreadyAdded) {
          interventionsToAdd.push(newIntervention);
          return interventionMapById[interventionId] = newIntervention;
        }
      }
    });
    return _.each(newOutcomes, function(newOutcome) {
      var existingData, existingOutcome, merged, mergedOutcome, newData, outcomeId, outcomeName, updatedData, updatedNewData;
      outcomeName = newOutcome.name;
      if (!outcomeName) {
        return;
      }
      outcomeId = "" + NMA_OUTCOME_PREFIX + (uuid.v5(outcomeName, questionNamespace));
      existingOutcome = outcomeMapById[outcomeId];
      if (existingOutcome) {
        existingData = existingOutcome.data || [];
        newData = newOutcome.data || [];
        updatedNewData = _.map(newData, function(dataItem) {
          return _.extend({}, dataItem, {
            outcomeId: outcomeId
          });
        });
        merged = _.chain(updatedNewData).concat(existingData).uniq(false, function(dataItem) {
          return "" + dataItem.interventionId + "-" + dataItem.comparatorId;
        }).value();
        return outcomeMapById[outcomeId] = _.extend({}, existingOutcome, {
          data: merged
        });
      } else {
        updatedData = _.map(newOutcome.data || [], function(dataItem) {
          return _.extend({}, dataItem, {
            outcomeId: outcomeId
          });
        });
        mergedOutcome = _.extend({}, newOutcome, {
          _id: outcomeId,
          questionId: questionId,
          data: updatedData
        });
        return outcomeMapById[outcomeId] = mergedOutcome;
      }
    });
  });
  updatedQuestion = currentQuestion.update('interventions', function(interventions) {
    if (interventions == null) {
      interventions = Immutable.List();
    }
    return Immutable.fromJS(_.chain(interventions.toJS())).concat(interventionsToAdd).uniq(false, function(intervention) {
      return intervention._id;
    }).value();
  }).update('outcomes', function(outcomeIds) {
    if (outcomeIds == null) {
      outcomeIds = Immutable.List();
    }
    return Immutable.fromJS(_.chain(outcomeIds.toJS())).concat(_.keys(outcomeMapById)).uniq().value();
  });
  allOutcomes = _.values(outcomeMapById);
  return {
    question: updatedQuestion,
    outcomes: allOutcomes
  };
};

module.exports = {
  addMissingInterventions: addMissingInterventions,
  calculateThreshold: calculateThreshold,
  CI_LEVEL: CI_LEVEL,
  gdtDataToNmaData: gdtDataToNmaData,
  gdtOutcomeDataToNmaOutcomeData: gdtOutcomeDataToNmaOutcomeData,
  gdtInterventionToNmaVizIntervention: gdtInterventionToNmaVizIntervention,
  gdtOutcomeToNmaVizOutcomeForImport: gdtOutcomeToNmaVizOutcomeForImport,
  gdtOutcomeTypeToDefaultEffectMeasure: gdtOutcomeTypeToDefaultEffectMeasure,
  gdtOutcomeTypeToNmaVizOutcomeType: gdtOutcomeTypeToNmaVizOutcomeType,
  getAllGdtDataForOutcome: getAllGdtDataForOutcome,
  getMappingStepData: getMappingStepData,
  getTranslationKeyPostFix: getTranslationKeyPostFix,
  importNMAData: importNMAData,
  mergeQuestionWithInterventionsAndOutcomes: mergeQuestionWithInterventionsAndOutcomes,
  nmaDataToGdtData: nmaDataToGdtData,
  nmaDataToVizData: nmaDataToVizData,
  nmaOutcomeDataToGdtData: nmaOutcomeDataToGdtData,
  parseImportResultsToGdtOutcome: parseImportResultsToGdtOutcome,
  regularGdtQuestionToNmaInterventionsAndOutcomes: regularGdtQuestionToNmaInterventionsAndOutcomes
};
